import { LOCATION_CHANGE } from 'redux-first-history'
import qs from 'qs'

import { get as getFromLocalStorage, Keys as LocalStorageKeys } from '~/util/localStorage'

import { locales } from '~/i18n'

const { hostname } = window.location

const persistedLocale = getFromLocalStorage(LocalStorageKeys.LOCALE, locales()[0])

export type ConfigState = {
  isInitialized: boolean
  dev: boolean
  keys: boolean
  demo: string
  locale: string
  translateError: boolean
  parcelshopHost: string
  parcelshopKey: string
  showPrintless: boolean
}

export const initState: ConfigState = {
  isInitialized: false,
  dev: false,
  keys: false,
  demo: '',
  locale: persistedLocale,
  translateError: false,
  parcelshopHost: '',
  parcelshopKey: '',
  showPrintless: false,
}

// eslint-disable-next-line @typescript-eslint/default-param-last, @typescript-eslint/no-explicit-any
export const configReducer = (state: ConfigState = initState, { type, payload }: any): ConfigState => {
  switch (type) {
    case LOCATION_CHANGE:
      // eslint-disable-next-line no-case-declarations
      const query = qs.parse(payload.location.search, { ignoreQueryPrefix: true, parseArrays: false })

      return state.isInitialized
        ? state
        : {
            keys: ((query.keys as string) || '').toLowerCase() === 'true',
            dev: process.env.NODE_ENV === 'development',
            demo: (query.demo as string) || '',
            locale: (query.locale as string) || persistedLocale,
            parcelshopHost: 'https://api-gw.dhlparcel.nl',
            parcelshopKey: 'AIzaSyDVQ47wiRESdobCG4mpLRGSnEIPFMUh6A4',
            isInitialized: true,
            translateError: false,
            showPrintless: hostname.includes('accept') || hostname.includes('localhost'),
          }
    default:
      return state
  }
}
